// eslint-disable-next-line no-magic-numbers
export const marriageStatusIds = [1, 2, 3] as const;

export type MarriageStatusId = (typeof marriageStatusIds)[number];

export const defaultMarriageStatus: MarriageStatusId = 1;

const marriageStatusLabels = ['未婚', '既婚', '離婚・死別'] as const;

type MarriageStatusLabel = (typeof marriageStatusLabels)[number];

type MarriageStatusAttribute = {
  key: number;
  value: string;
  label: MarriageStatusLabel;
};

export const createMarriageStatusAttributes = (): MarriageStatusAttribute[] => [
  {
    key: 1,
    value: '1',
    label: '未婚',
  } as const,
  {
    key: 2,
    value: '2',
    label: '既婚',
  } as const,
  {
    key: 3,
    value: '3',
    label: '離婚・死別',
  } as const,
];

export const isMarriageStatusId = (
  value: unknown,
): value is MarriageStatusId => {
  if (typeof value !== 'number') {
    return false;
  }

  return marriageStatusIds.includes(value as MarriageStatusId);
};
